export class Seat {
  constructor(public seat_id: string,
              public seat_no: number,
              public seat_status: string) {
  }

}
